import { render, staticRenderFns } from "./GlCpuCores.vue?vue&type=template&id=04979990&scoped=true&"
import script from "./GlCpuCores.vue?vue&type=script&lang=js&"
export * from "./GlCpuCores.vue?vue&type=script&lang=js&"
import style0 from "./GlCpuCores.vue?vue&type=style&index=0&id=04979990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04979990",
  null
  
)

export default component.exports